import React, { FC, useContext } from 'react'
import { EditElementWrapper } from '../EditElementWrapper'

import EditModeVideo from './modes/edit/EditModeVideo'
import { useTopicForEditQuery } from '../../../topic-edit-page/TopicEditPage'

import './EditMediaElement.less'
import { TopicElementModelAsEditor } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { TopicEditingContext } from '../../../topic-edit-page/TopicEditContext'

export const EditMediaElement: FC<{
  isMultiPage: boolean
  element: TopicElementModelAsEditor
}> = ({ isMultiPage, element }) => {
  const { topic } = useContext(TopicEditingContext)
  const { refetch: refetchTopic } = useTopicForEditQuery()

  return (
    <EditElementWrapper
      element={element}
      isMultiPage={isMultiPage}
      isMediaElement
    >
      <EditModeVideo
        workspaceId={topic.workspace_id as any}
        topicId={topic.id}
        elementId={element.id}
        fetchTopic={refetchTopic}
      />
    </EditElementWrapper>
  )
}
